<template>
  <FeedbackStep :title="title" :number="number">
    <template v-slot:content>
      <div class="feedback-form">
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q1Rate1"
            type="radio"
            name="q1Rate"
            value="1 - źle"
            v-model.trim="form.answer_q1"
            @input="delayTouch($v.form.answer_q1)"
          />
          <label for="q1Rate1" class="form__label">1 - źle</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q1Rate2"
            type="radio"
            name="q1Rate"
            value="2"
            v-model.trim="form.answer_q1"
            @input="delayTouch($v.form.answer_q1)"
          />
          <label for="q1Rate2" class="form__label">2</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q1Rate3"
            type="radio"
            name="q1Rate"
            value="3"
            v-model.trim="form.answer_q1"
            @input="delayTouch($v.form.answer_q1)"
          />
          <label for="q1Rate3" class="form__label">3</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q1Rate4"
            type="radio"
            name="q1Rate"
            value="4"
            v-model.trim="form.answer_q1"
            @input="delayTouch($v.form.answer_q1)"
          />
          <label for="q1Rate4" class="form__label">4</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q1Rate5"
            type="radio"
            name="q1Rate"
            value="5 - bardzo dobrze"
            v-model.trim="form.answer_q1"
            @input="delayTouch($v.form.answer_q1)"
          />
          <label for="q1Rate5" class="form__label">5 - bardzo dobrze</label>
        </div>
      </div>
    </template>
  </FeedbackStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import FeedbackStep from '../global/FeedbackStep.vue';

export default {
  name: 'Question1',
  components: { FeedbackStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Jak ocenia Pan/Pani obsługę klienta w Solveit?',
    number: 1,
    form: {
      answer_q1: null,
    },
  }),
  validations: {
    form: {
      answer_q1: {
        required,
      },
    },
  },
};
</script>
